export const GENERIC_ATTRIBUTES = 'item-attributes';
export const PRODUCT_CODE = 'product-code';
export const ITEM_CODE = 'item-code';
export const ITEM_NAME = 'item-name';
export const GENERIC_MEDIA = 'assets-attributes';
export const GENERIC_PRODUCT = 'product-attributes';
export const BIM_FILE_TYPES = 'bim-file-types';
export const INSTALLATION_GUIDELINES_SET ='installation-guidelines-set';
export const INSTALLATION_GUIDELINES ='installation-guidelines';
export const TECH_MANUAL_SET ='technical-manual-set';
export const TECH_MANUAL ='technical-manual';
export const TECH_IMAGE ='technical-image';

export const CAPACITY_SIZE = 'capacity-size';
export const ITEM_TAPHOLES = 'item-tapholes';
export const COLOR = 'colour';
export const SHAPE = 'shape';
export const PRODUCT_TYPE = 'product-types';
export const RANGE = 'range';
export const ITEM_MATERIAL = 'item-material';
export const COATING_METHOD = 'coating-method';
export const TRAP_TYPE = 'trap-type';

export const INLET_TYPE = 'inlet-type';
export const PAN_HEIGHT = 'pan-height';
export const PAN_PROJECTION = 'pan-projection-size';
export const CLEAN_FLUSH = 'clean-flush';
export const MOUNT_TYPE = 'mount-type';
export const OUTLET_TYPE = 'outlet-type';
export const OUTLET_LENGTH = 'outlet-length';
export const CARTRIDGE_SIZE = 'cartidge-size';
export const CARTRIDGE_TYPE = 'cartridge-type';
export const LITRES_PER_MINUTE = 'litres-per-minute';
export const WELS_FLOWRATE_1 = 'wels-with-flow-rate-flush-volume-1';
export const WELS_FLOWRATE_2 = 'wels-with-flow-rate-flush-volume-2';
export const SPRAY_FUNCTIONS = 'spray-functions';
export const RAIL_LENGTH = 'rail-length';
export const SHOWER_HEAD_SIZE = 'shower-head-diameter';
export const OVERFLOW = 'overflow';
export const TAPHOLES = 'number-of-tap-holes';
export const CAPACITY_TO_OVERFLOW = 'capacity-to-overflow';
export const SURFACE_FINISH = 'surface-finish';
export const BOWL_POSITION = 'bowl-position';
export const WASTE_POSITION = 'waste-position';

export const ISCOMPLIANT = 'AS1428.1 Accessible';
export const ISAMBULANT = 'AS1428.1 Ambulant';
export const INDEPENDENT_LIVING_COMPLAINT = 'Independent Living Compliant';
export const ISNZCOMPLAINT = 'NZS 4121 Compliant';
export const BRAND_FACET_ATTRIBUTE = 'searchableAttributes.brand';
export const RANGE_FACET_ATTRIBUTE = 'searchableAttributes.range';
export const FILE_TYPES_FACET_ATTRIBUTE = 'variants.attributes.bim-file-types';
export const THUMBNAIL = 'https://stuberaueastprod8b0c.blob.core.windows.net/blankimageblob/product-thumbnail.jpg';
